<template>
   <!-- [theme class css in cms-themes.scss] -->
   <div class="xl:py-30 py-12 text-center md:py-20 lg:py-24" :class="`theme-${containerTheme}`">
      <div class="mx-auto max-w-md px-6 md:px-0">
         <Kicker v-if="kicker" :text="kicker" />

         <h2 class="h2 text-3xl lg:text-4xl lg:leading-8">{{ heading }}</h2>

         <div v-if="description" class="pt-8 lg:px-8">
            <RichTextRenderer :document="description" />
         </div>

         <PageCTAItems
            v-if="ctas && ctas.length > 0"
            :ctas="ctas"
            :theme="containerTheme"
            :isPageCta="true"
            class="mt-8 justify-center"
         />
      </div>
   </div>
</template>

<script setup lang="ts">
import type { CTAItemData } from "@/components/ui/buttons/PageCTAItems.vue";
import { Theme, type RichText, type ContainerTheme } from "@/types";

// props
// -----------------------------------------
const props = withDefaults(
   defineProps<{
      heading: string;
      kicker?: string;
      description?: RichText;
      ctas?: CTAItemData[];
      theme?: ContainerTheme;
   }>(),
   {
      theme: Theme.BrandDark,
   }
);

const containerTheme = computed(() => (props.theme ? props.theme : Theme.BrandDark));
</script>

<style scoped></style>
